var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.pageClass},[(_vm.title)?_c('h1',{class:_vm.titleClass},[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.subtitle)?_c('h2',{staticClass:"my-3 my-md-6",class:_vm.subtitleClass},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e(),_c('div',{class:_vm.pageSlotClass},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }